export default "__VITE_ASSET__cqVaZewN__"